import React from 'react'
import { DataTable } from '@paypalcorp/pp-react'
import CardCurrencyBrandIntroACDC from './CardCurrencyBrandIntroACDC'
import CardCurrencyBrandLegendACDC from './CardCurrencyBrandLegendACDC'
import SearchableTableACDCNotCollapsed from './SearchableTableACDCNotCollapsed'

const CardCurrencyBrandTable = () => {
  return (
    <>
      <CardCurrencyBrandIntroACDC />
      <SearchableTableACDCNotCollapsed
        rowDataName="card_supported_currencies_acdc_focus_row"
        colDataName="card_supported_currencies_acdc_focus_column"
        searchKeys={['country.value', 'country.countryCode']}
        searchable={true}
      />
      <CardCurrencyBrandLegendACDC />
    </>
  )
}

export default CardCurrencyBrandTable
